export default __webpack_public_path__ + "static/media/MBOX.02d3f839.svg";